import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import { useParams } from 'react-router-dom';
import Forms from './components/Forms';

const CadastrosVeiculoMain = ({
  isReadOnly = false,
  id: propId,
  hideHeader = false,
}) => {
  const { id: paramId } = useParams();
  const id = propId || paramId;
  const isEditing = !!id && !isReadOnly;
  const isViewing = isReadOnly;

  return (
    <Container fluid>
      {!hideHeader && (
        <Row>
          <Col md={12}>
            <PageHeader
              title=""
              routeSegments={[
                { name: 'Inicio' },
                { name: 'Veiculos', route: '/pages/veiculos' },
                {
                  name: isViewing
                    ? 'Detalhes do Veiculo'
                    : isEditing
                      ? 'Editar Veiculo'
                      : 'Novo Veiculo',
                },
              ]}
            />
          </Col>
        </Row>
      )}

      <Row>
        <Col md={12}>
          <Forms isReadOnly={isReadOnly} />
        </Col>
      </Row>
    </Container>
  );
};

export default CadastrosVeiculoMain;
